// @mui
import { Box, Typography, Stack } from '@mui/material';

// ----------------------------------------------------------------------

export default function BlockContent() {
  return (
    <Stack
      spacing={2}
      alignItems="center"
      justifyContent="center"
      direction={{ xs: 'column', md: 'row' }}
      sx={{ width: 1, textAlign: { xs: 'center', md: 'left' } }}
    >
      <Box sx={{ p: 3 }}>
        <Typography gutterBottom variant="h5">
          Arraste ou selecione arquivos
        </Typography>

        <Typography variant="body2" sx={{ color: 'text.secondary' }}>
          Solte os arquivos aqui ou clique para selecionar
        </Typography>
      </Box>
    </Stack>
  );
}
